<ul
    #dropdown
    [@dropdownVisible]="open ? 'show' : 'hide'"
    class="select-dropdown"
    [class.active]="open && animateComplete"
    [style.top]="dropdownPosition?.top"
    [style.left]="dropdownPosition?.left"
    [style.width]="dropdownPosition?.width"
    clickOutside
    (clickOutside)="closeDropdown()"
>
    @if (!renderedTop) {
        @if (
            selectConfig && (selectConfig.options.length < selectConfig.includeSearchAfterN || !selectConfig.canSearch)
        ) {
            <li class="selected-option">
                @if (!selectConfig.selectedOption) {
                    <span class="dropdown-value">{{ selectConfig.placeholder }}</span>
                }
                @if (selectConfig.selectedOption) {
                    <span class="dropdown-value">
                        @if (selectConfig.optionTemplate && !selectConfig.isResultPlainText) {
                            <ng-container
                                *ngTemplateOutlet="
                                    selectConfig.optionTemplate;
                                    context: {
                                        $implicit: selectConfig.selectedOption,
                                        label: getLabel(selectConfig.selectedOption),
                                    }
                                "
                            ></ng-container>
                        } @else {
                            {{ getLabel(selectConfig.selectedOption) }}
                        }
                    </span>
                }
            </li>
        }
        @if (
            selectConfig && selectConfig.canSearch && selectConfig.options.length >= selectConfig.includeSearchAfterN
        ) {
            <li class="search-option">
                <span class="dropdown-value">
                    <label class="select-search-label">
                        <input
                            class="exclude-modal-styling"
                            tabindex="0"
                            #searchInput
                            type="text"
                            [(ngModel)]="searchValue"
                            (input)="search()"
                        />
                        <i class="fa fa-search"></i>
                    </label>
                </span>
            </li>
        }
    }
    @if (selectConfig && selectConfig.canDeselect) {
        <li
            class="dropdown-option"
            tabindex="0"
            (focus)="setListItemFocus(selectConfig.deselectValue)"
            (click)="optionSelected(selectConfig.deselectValue)"
        >
            <span class="dropdown-value">
                {{ selectConfig.deselectLabel }}
            </span>
        </li>
    }
    @for (option of selectConfig?.searchableOptions; track $index; let i = $index) {
        <li
            class="dropdown-option"
            tabindex="0"
            [id]="'option' + i"
            [class.selected]="option === selectConfig.selectedOption"
            [class.disabled]="option[selectConfig.disabledProperty]"
            (focus)="setListItemFocus(option)"
            (click)="optionSelected(option)"
        >
            <span
                class="dropdown-value"
                [ngClass]="
                    selectConfig.optionStyleClass && selectConfig.optionStyleClass(option[selectConfig.valueProperty])
                "
                [ngStyle]="{ 'text-align': selectConfig.alignOptionText }"
                [title]="selectConfig.isPrimitive ? option : getTitle(option)"
            >
                @if (selectConfig.optionTemplate) {
                    <ng-container
                        *ngTemplateOutlet="
                            selectConfig.optionTemplate;
                            context: { $implicit: option, label: getLabel(option) }
                        "
                    ></ng-container>
                } @else {
                    {{ getLabel(option) }}
                }
            </span>
        </li>
    }
    @if (
        !searchValue &&
        (selectConfig?.isShowMoreFromParent ||
            (selectConfig?.maxListSize && selectConfig?.searchableOptions.length < searchResultCount))
    ) {
        <li class="dropdown-option" (click)="showMore($event)">
            <span class="dropdown-value show-more"><i class="fa fa-caret-down"></i> Show More</span>
        </li>
    }
    @if (renderedTop) {
        @if (
            selectConfig && (selectConfig.options.length < selectConfig.includeSearchAfterN || !selectConfig.canSearch)
        ) {
            <li class="selected-option bottom">
                @if (!selectConfig.selectedOption) {
                    <span class="dropdown-value">{{ selectConfig.placeholder }}</span>
                }
                @if (selectConfig.selectedOption) {
                    <span class="dropdown-value">
                        @if (selectConfig.optionTemplate && !selectConfig.isResultPlainText) {
                            <ng-container
                                *ngTemplateOutlet="
                                    selectConfig.optionTemplate;
                                    context: {
                                        $implicit: selectConfig.selectedOption,
                                        label: getLabel(selectConfig.selectedOption),
                                    }
                                "
                            ></ng-container>
                        } @else {
                            {{ getLabel(selectConfig.selectedOption) }}
                        }
                    </span>
                }
            </li>
        }
        @if (
            selectConfig && selectConfig.canSearch && selectConfig.options.length >= selectConfig.includeSearchAfterN
        ) {
            <li class="search-option bottom">
                <span class="dropdown-value">
                    <label class="select-search-label">
                        <input
                            class="exclude-modal-styling"
                            tabindex="0"
                            #searchInput
                            type="text"
                            [(ngModel)]="searchValue"
                            (input)="search()"
                        />
                        <i class="fa fa-search"></i>
                    </label>
                </span>
            </li>
        }
    }
</ul>
